import {useSearchParams, useNavigate, useLocation} from 'react-router-dom'
import {useState, useEffect} from 'react'
import axios from 'axios'
import {defaultpropsalertform} from 'entries/alertform'
import {ProgressFullScreen} from 'molecules'
import AlertForm from 'template/Form/AlertForm'
import {VmView} from 'components'
import QueryString from 'qs'
import {ModalCariEtiket} from './modal-etiket'
import {TextField} from 'pages/prd-data-obat/TextField'
import {Controller, FormProvider, useForm} from 'react-hook-form'
import {ModalPilihObat} from './modal-obat'
import {toCurrency} from 'utils/functions'

// --------------------------------------------

const inputForm = [
  {
    name: 'obatkode',
    label: 'Kode Obat Racikan',
    required: true,
  },
  {
    name: 'obatnama',
    label: 'Nama Obat Racikan',
    required: true,
  },
  {
    name: 'obatetiketcatatan',
    label: 'Etiket/Aturan Pakai',
    required: true,
  },
  {
    name: 'price',
    label: 'Estimasi Harga',
    disabled: true,
  },
]

// --------------------------------------------

export default function Index({
  successLabel = 'Berhasil Menyimpan data',
  errorLabel = 'Terjadi kesalahan saat menyimpan data',
}) {
  const [searchParams] = useSearchParams()
  const uid = searchParams.get('dctid')
  const obatid = searchParams.get('obatid')
  const navigate = useNavigate()
  const location = useLocation()
  const initialData = location?.state?.item || ''
  const label = initialData ? 'Ubah Data Racikan' : 'Tambah Data Racikan'

  const [loading, setLoading] = useState(false)
  const [propsalertform, setpropsalertform] = useState(defaultpropsalertform)
  const [isModalOpen, setModalOpen] = useState(false)
  const [isModalObatOpen, setModalObatOpen] = useState(false)
  const [dataEtiket, setDataEtiket] = useState([])
  const [keyword, setKeyword] = useState('')

  const openModal = () => setModalOpen(true)
  const closeModal = () => setModalOpen(false)

  const openModalObat = () => setModalObatOpen(true)
  const closeModalObat = () => setModalObatOpen(false)

  const methods = useForm({
    defaultValues: {
      obatkode: initialData?.obatkode ?? '',
      obatnama: initialData?.obatnama ?? '',
      obatetiketcatatan: initialData?.obatetiketcatatan ?? '',
      price: initialData?.price ?? '',
      itemObat: initialData?.itemObat ?? [],
    },
  })

  const {control, handleSubmit, getValues, reset} = methods

  const apiEndpoint = `${process.env.REACT_APP_BASE_URL_DOKTER}/prd-data-racikan/create`

  const closeAlert = () => setpropsalertform(defaultpropsalertform)
  const openAlert = (caption, type, onConfirm = closeAlert) => {
    setpropsalertform({
      ...propsalertform,
      type,
      visible: true,
      children: <>{caption}</>,
      onConfirm: onConfirm,
      onClose: closeAlert,
      onCancel: closeAlert,
    })
  }

  const handleChangeCart = (field, index, val = 0) => {
    const items = getValues('itemObat')
    const item = items[index]
    let satuan = item?.satuan
    let harga = item?.harga

    if (field === 'satuan') satuan = val
    if (field === 'harga') harga = val

    const total = item.jumlah * item?.satuanObat[satuan][`hj${harga}`]

    items[index] = {
      ...item,
      total,
      satuan,
      harga,
    }

    reset({
      ...getValues(),
      itemObat: items,
      price: toCurrency(items.reduce((acc, item) => acc + item.total, 0)),
    })
  }

  const onSubmit = async data => {
    if (data?.itemObat.length === 0) {
      return openAlert('Data Obat tidak boleh kosong', 3, () => {})
    }

    setLoading(true)

    try {
      const result = await axios
        .post(
          apiEndpoint,
          QueryString.stringify({
            a: 'dk13',
            reg: 'dbdok',
            uid,
            data,
            obatid,
            action: !!initialData ? 'update' : 'create',
          })
        )
        .then(({data}) => data)

      if (result?.status === 1) {
        openAlert('Berhasil mengubah data', 1, () =>
          navigate('/prd-data-racikan?dctid=' + uid)
        )
      } else {
        openAlert(data?.message, 3, () => {})
      }
    } catch (err) {
      openAlert('[EC-8] ' + errorLabel, 3)
    } finally {
      setLoading(false)
    }
  }

  const fetchEtiket = async () => {
    axios
      .post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-etiket/index',
        QueryString.stringify({
          a: 'dk13',
          reg: 'dbdok',
          uid,
          etiaktif: 1,
          etiketerangan: '',
          etinama: '',
          limit: 1000,
          offset: 0,
        })
      )
      .then(({data: res}) => {
        if (res) {
          setDataEtiket(res)
        } else {
          console.log('Error get Data Etiket')
        }
      })
      .catch(err => {
        console.log('Error get Data Etiket', err.message)
      })
      .finally(() => {
        // this.setState({gettingInitialData: false})
      })
  }

  const fetchObatKode = async () => {
    axios
      .post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-racikan/getobatkode',
        QueryString.stringify({
          a: 'dk13',
          reg: 'dbdok',
          uid,
        })
      )
      .then(({data: res}) => {
        if (res) {
          reset({
            ...getValues(),
            obatkode: res,
          })
        } else {
          console.log('Error get Data Etiket')
        }
      })
      .catch(err => {
        console.log('Error get Data Etiket', err.message)
      })
  }

  useEffect(() => {
    if (!initialData) fetchObatKode()
    fetchEtiket()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialData])

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <VmView className="p-4">
          {/* Section Header */}
          <VmView className="bg-blue-500 text-white text-2xl font-semibold p-4 rounded-t-2xl">
            {label}
          </VmView>

          {/* Section body */}
          <VmView className="p-4 flex-1 border-x-2 border-b-2 border-gray-200 rounded-b-2xl rounded-x-2xl mb-[80px]">
            {inputForm.map((field, index) => (
              <VmView key={index} className="mb-4">
                <TextField key={index} openModal={openModal} {...field} />
              </VmView>
            ))}

            <label className="text-2xl mt-4">Data Obat</label>
            <VmView className="flex w-full">
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded-lg"
                value={keyword}
                onKeyDown={e => {
                  if (e.key === 'Enter' ){
                    e.preventDefault()
                    openModalObat()
                  }
                }}
                onChange={e => setKeyword(e.target.value)}
              />
              <button
                type="button"
                className="info px-1 rounded-lg ml-2 w-1/4"
                onClick={openModalObat}
              >
                Cari Obat
              </button>
            </VmView>

            <VmView className="mt-4 overflow-x-auto min-w-full">
              <table className="w-full min-w-full">
                <thead>
                  <tr>
                    <th className="min-w-[150px] border p-2">Aksi</th>
                    <th className="min-w-[150px] border p-2">Kode Obat</th>
                    <th className="min-w-[150px] border p-2">Nama Obat</th>
                    <th className="min-w-[100px] border p-2">Jumlah</th>
                    <th className="min-w-[150px] border p-2">Satuan</th>
                    <th className="min-w-[200px] border p-2">Harga</th>
                    <th className="min-w-[200px] border p-2">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {getValues('itemObat').map((item, index) => (
                    <tr key={`itm-${index}`}>
                      <td className="border p-2">
                        <button
                          type="button"
                          onClick={() => {
                            const items = getValues('itemObat')
                            items.splice(index, 1)
                            reset({
                              ...getValues(),
                              itemObat: items,
                              price: toCurrency(
                                items.reduce(
                                  (acc, item) => acc + parseInt(item.total),
                                  0
                                )
                              ),
                            })
                          }}
                          className="danger-outline p-2 px-4 rounded-lg"
                        >
                          Hapus
                        </button>
                      </td>
                      <td className="border p-2">{item?.obatkode}</td>
                      <td className="border p-2">{item?.obatnama}</td>
                      <td className="border p-2">
                        <TextField
                          name={`itemObat[${index}].jumlah`}
                          type="number"
                          onBlur={() => handleChangeCart('jumlah', index)}
                        />
                      </td>
                      <td className="border p-2">
                        <Controller
                          name={`itemObat[${index}].satuan`}
                          control={control}
                          render={({field}) => (
                            <select
                              {...field}
                              onChange={e =>
                                handleChangeCart(
                                  'satuan',
                                  index,
                                  e.target.value
                                )
                              }
                              className="w-full p-2 rounded-xl focus:outline-none ring-1 ring-gray-300 focus:ring-blue-500 focus:ring-2 px-4"
                            >
                              {item?.satuanObat.map((item, index) => (
                                <option value={index} key={`sat-${index}`}>
                                  {item?.sonama}
                                </option>
                              ))}
                            </select>
                          )}
                        />
                      </td>
                      <td className="border p-2">
                        <Controller
                          name={`itemObat[${index}].harga`}
                          control={control}
                          render={({field}) => (
                            <select
                              {...field}
                              onChange={e =>
                                handleChangeCart('harga', index, e.target.value)
                              }
                              className="w-full p-2 rounded-xl focus:outline-none ring-1 ring-gray-300 focus:ring-blue-500 focus:ring-2 px-4"
                            >
                              {[1, 2, 3].map((item, index) => (
                                <option value={item} key={`sat-${index}`}>
                                  Harga Jual {item}
                                </option>
                              ))}
                            </select>
                          )}
                        />
                      </td>
                      <td className="border p-2">{toCurrency(item?.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </VmView>
          </VmView>

          {/* Section Footer */}
          <VmView className="fixed bottom-0 left-0 w-full bg-white shadow-md p-4 flex justify-between">
            <button
              type="submit"
              disabled={loading}
              className={`success p-2 px-4 rounded-lg ${
                loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              Simpan
            </button>

            <button
              type="button"
              onClick={() => navigate('/prd-data-racikan?dctid=' + uid)}
              className="danger-outline p-2 px-4 rounded-lg"
            >
              Batal
            </button>
          </VmView>

          <ProgressFullScreen visible={loading} />
          <AlertForm {...{...propsalertform, noText: false, yesText: 'Ok'}} />
          <ModalCariEtiket
            isOpen={isModalOpen}
            onClose={closeModal}
            items={dataEtiket}
            onSelectEtiket={item => {
              reset({
                ...getValues(),
                obatetiketcatatan: item.etiketerangan,
              })
              closeModal()
            }}
          />
        </VmView>
      </form>
      <ModalPilihObat
        uid={uid}
        isOpen={isModalObatOpen}
        onClose={closeModalObat}
        keywrd={keyword}
        onSelectObat={item => {
          // validate, apakah ada obatid & satuan yang sama
          const isExist = getValues('itemObat').find(
            itm =>
              itm.obatid === item.obatid &&
              itm.satuan === 0 &&
              item.satuanObat[0]?.sonama === itm.satuanObat[0]?.sonama
          )

          if (isExist) {
            return openAlert('Obat sudah ada dalam list', 3, () => {})
          }

          reset({
            ...getValues(),
            itemObat: [
              ...getValues().itemObat,
              {
                ...item,
                jumlah: 1,
                harga: 1,
                satuan: 0,
                total: item?.satuanObat[0]?.hj1 ?? 0,
              },
            ],
          })
          reset({
            ...getValues(),
            price: toCurrency(
              getValues('itemObat').reduce(
                (acc, item) => acc + parseInt(item.total),
                0
              )
            ),
          })
          closeModalObat()
        }}
      />
    </FormProvider>
  )
}
